import _objectSpread from "/Users/adway/Documents/agora.io/ad-manage-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/adway/Documents/agora.io/ad-manage-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
// import { getDict } from '@/utils/dictionary'
import { getHistoryConfigInfos } from '@/api/adConfig';
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 10,
      tableData: [],
      searchInfo: {},
      listApi: getHistoryConfigInfos
    };
  },
  methods: {
    filterDict: function filterDict(value, type) {
      var rowLabel = this[type + 'Options'] && this[type + 'Options'].filter(function (item) {
        return item.value === value;
      });
      return rowLabel && rowLabel[0] && rowLabel[0].label;
    },

    /* async getDict(type) {
      const dicts = await getDict(type)
      this[type + 'Options'] = dicts
      return dicts
    }, */
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this.pageSize;
                _context.next = 4;
                return _this.listApi(_objectSpread(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this.searchInfo), _this.$route.query));

              case 4:
                table = _context.sent;

                if (table.code === 0) {
                  _this.tableData = table.data.list;
                  _this.total = table.data.total;
                  _this.page = table.data.page;
                  _this.pageSize = table.data.pageSize;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};